export default __webpack_public_path__ + "static/media/iconCreatedBy.9d4c3f52.svg";